import { ugcBriefGaps, type BriefTemplateContent, type UgcBriefGap } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';
import { InlineErrorBanner } from '@/pages/collabs/brief-templates/editor/controls/InlineErrorBanner';

const GAPS_KEY = 'invitations.modal.collab.wizard.terms.ugc.gaps';

/** The gaps this step names itself; the amount and the deadlines already have their banners. */
const NAMED_HERE: readonly UgcBriefGap[] = ['deliverables', 'delivery', 'usage_rights'];

/** The ads share is the one rights gap the amount on this step can cause or cure. */
const adsShareAtOrAboveAmount = (content: BriefTemplateContent): boolean => {
  const share = content.usageRights.adsShareCents ?? 0;
  const amount = content.compensation.fixedPayment?.amountCents ?? 0;
  return content.usageRights.channels.includes('paid_ads') && amount > 0 && share >= amount;
};

/**
 * What still stops a UGC proposal, one banner per gap, read from the shared
 * rule the send applies, each saying what to fix and where.
 */
export const CollabTermsUgcGaps = ({ content }: { content: BriefTemplateContent }) => {
  const { t } = useTranslation();
  const gaps = ugcBriefGaps(content).filter((gap) => NAMED_HERE.includes(gap));

  return (
    <>
      {gaps.map((gap) => {
        const key =
          gap === 'usage_rights'
            ? adsShareAtOrAboveAmount(content)
              ? 'adsShare'
              : 'usageRights'
            : gap;
        return <InlineErrorBanner key={gap} message={t(`${GAPS_KEY}.${key}`)} />;
      })}
    </>
  );
};
